<ng-content select=".header"></ng-content>
<ng-content select=".content"></ng-content>
<ng-content select=".footer"></ng-content>
